"use strict";
import { __exports as e } from "./index.es307.js";
import { __require as f } from "./index.es308.js";
import { __require as _ } from "./index.es309.js";
var i;
function R() {
  return i ? e : (i = 1, (function(r) {
    Object.defineProperty(r, "__esModule", {
      value: !0
    });
    function n(c, o) {
      for (var u in o) Object.defineProperty(c, u, {
        enumerable: !0,
        get: o[u]
      });
    }
    n(r, {
      getSortedRouteObjects: function() {
        return t.getSortedRouteObjects;
      },
      getSortedRoutes: function() {
        return t.getSortedRoutes;
      },
      isDynamicRoute: function() {
        return s.isDynamicRoute;
      }
    });
    const t = f(), s = _();
  })(e), e);
}
export {
  R as __require
};
//# sourceMappingURL=index.es276.js.map
